import { SET_CURRENT_USER, LOGIN_ERROR, HIDE_UTIL_MODAL, SIGN_USER_OUT } from './actionTypes'
import firebase from 'firebase';
import { googleAuthProvider, facebookAuthProvider, firebaseAuth } from '../../utils/firebase'
import { showMessageModal, hideUtilModal } from './miscActions';


export const registerWithEmail=(email, password, history) => dispatch =>{
  firebaseAuth.createUserWithEmailAndPassword(email, password).then(function(){
    const feedback = {
      type: 'success',
      txt:  'Registratie gelukt. Voltooi uw profiel'
    }
    dispatch(hideUtilModal())
    dispatch(showMessageModal(feedback))
    history.push('/user')
  }).catch(function(error){
    const errorMessage = error.code === 'auth/invalid-email' ? 'Controleer het e-mailadres' : error.code === 'auth/weak-password' ? 'Wachtwoord moet minimaal 6 tekens bevatten' : error.message
    const feedback = {
      type: 'warning',
      txt: errorMessage
    }
    dispatch(showMessageModal(feedback))
  })
}


export const emailSignIn=(email, password) => dispatch =>{
  firebaseAuth.signInWithEmailAndPassword(email, password).then(function(){
    dispatch(hideUtilModal())
  }).catch(function(error){
    const errorMessage = error.code === 'auth/wrong-password' ? 'Ongeldig wachtwoord' : error.code === 'auth/user-not-found' ? 'Controleer het e-mailadres' : error.message
    const feedback = {
      type: 'warning',
      txt: errorMessage
    }
    dispatch(showMessageModal(feedback))
  })
}

export const facebookLogin = () => (dispatch) =>{
  firebase.auth().signInWithPopup(facebookAuthProvider).then(function(result){
    const user = result.user
    dispatch({
      type: SET_CURRENT_USER,
      payload: user
    })
    dispatch({
      type: HIDE_UTIL_MODAL
    })
  }).catch(err => dispatch({  
    type: LOGIN_ERROR,
    payload: err
  }))
}

export const googleLogin = () => (dispatch) =>{
  firebase.auth().signInWithPopup(googleAuthProvider).then(function(result){
    const user = result.user
    dispatch({
      type: SET_CURRENT_USER,
      payload: user
    })
    dispatch({
      type: HIDE_UTIL_MODAL
    })
  }).catch(err => dispatch({  
    type: LOGIN_ERROR,
    payload: err
  }))
}

export const checkUserAuthStatus = () => dispatch =>{
  firebaseAuth.onAuthStateChanged(function(user){
    if(user){
      dispatch({
        type: SET_CURRENT_USER,
        payload: user
      })
    }
  })
}

export const signOut = () => dispatch => {
  firebaseAuth.signOut().then(function(){
    dispatch({
      type: SIGN_USER_OUT
    })
  })  
}
